import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  modalSteps,
  alert,
  stateAlert,
  modalError,
  errortext,
} from "../../../Store/simulate/actions";
import Button from "../../../Components/FormElements/Button";
import ModalFiltering from "../../../Components/FormElements/ModalFiltering";

import { API } from "aws-amplify";
import InfoMessage from "../../../Components/FormElements/InfoMessage";

const modalAprobar = ({ numCotizacion }: any) => {
  const [loadingClick, setLoadingClick] = useState<any>(false);
  const [infoMessage, setInfoMessage] = useState<any>(false);
  const { channel } = useSelector((state: any) => state.login);

  let history = useHistory();
  const dispatch = useDispatch();

  const quoteDataModal = useSelector(
    (state: any) => state.quote.policy.quoteDataModal
  );

  const handleCancelQuote = () => {
    dispatch(modalSteps(false));
  };

  const handleValidationRoute = () => {
    const perfilAprobador = ["admin", "suscript"];

    if (perfilAprobador.includes(channel)) {
      history.push("/aprobaciones");
    } else {
      history.push("/cotizaciones");
    }
  };

  const handleAprobar = async () => {
    setLoadingClick(true);
    setInfoMessage(true);
    if (Object.keys(quoteDataModal).length === 0) {
      dispatch(modalSteps(false));
      handleValidationRoute();

      dispatch(modalSteps(false));
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "danger",
          title: "¡Error de datos",
          message: "Ocurrio un error al cargar",
        })
      );
    }
    try {
      const response = await API.post(
        "api-rentas",
        "/suscription",
        quoteDataModal
      );
      if (response.status) {
        handleValidationRoute();
        dispatch(modalSteps(false));
        dispatch(stateAlert(true));
        dispatch(
          alert({
            type: "success",
            title: "¡Aprobación enviada! ",
            message: `La cotización nro. ${numCotizacion} se encuentra en espera de ser emitida.`,
          })
        );
        setLoadingClick(false);
        setInfoMessage(false);
      } else {
        const getMessage = JSON.parse(response.data);
        const { code } = getMessage.error;

        const TYPES: any = {
          default: "default",
          ERRNUMRELINGRESO: "ERRNUMRELINGRESO",
          ERRNUMOBLIGACION: "ERRNUMOBLIGACION",
          ["VIDA-TRANSACCION-006"]: "VIDA-TRANSACCION-006",
          ERRNUMRELINGRESONUMID: "ERRNUMRELINGRESONUMID",
          ["VIDA-TRANSACCION-005"]: "VIDA-TRANSACCION-005",
        };

        const modifier = TYPES[code] || "default";

        dispatch(modalSteps(false));
        dispatch(modalError(true));
        dispatch(errortext(modifier));
        setLoadingClick(false);
        setInfoMessage(false);
      }
    } catch (err) {
      handleValidationRoute();
      dispatch(modalSteps(false));
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "danger",
          title: "¡Error de emisión",
          message: "Ocurrio un error al intentar aprobar",
        })
      );
    }
  };

  return (
    <ModalFiltering className="modal-result is-midle" variant={loadingClick}>
      <h2 className="modal-result__title">
        Tu cotización aprobada pasará a validación
      </h2>
      <div className="modal-result__desc">
        Luego, su estado cambiará automaticamente a <span>Emitida</span> o{" "}
        <span>Error al emitir.</span>
      </div>
      {infoMessage && (
        <InfoMessage text="Esta ventana estará activa por unos segundos mientras se realiza la validación." />
      )}
      <div className="actions">
        <Button
          className={`${loadingClick ? "is-loading" : ""} actions__continue`}
          onClick={handleAprobar}
        >
          Aceptar
        </Button>
        <Button
          className="is-secondary actions__cancel"
          onClick={handleCancelQuote}
          disabled={loadingClick ? true : false}
        >
          Cancelar
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default modalAprobar;
